import { render, staticRenderFns } from "./PasswordResetRequestForm.vue?vue&type=template&id=b62020f0&scoped=true"
import script from "./PasswordResetRequestForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetRequestForm.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/shared-styles/login-forms.css?vue&type=style&index=0&id=b62020f0&prod&scoped=true&lang=css&external"
import style1 from "./PasswordResetRequestForm.vue?vue&type=style&index=1&id=b62020f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62020f0",
  null
  
)

export default component.exports